export function formatAggregateCheck(check) {
  return `check has ${check.children.length} child checks`;
}
